var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bread-crumb',{attrs:{"list-classes":"breadcrumb-links breadcrumb-dark"}},[_c('BreadCrumbItem',[_c('i',{staticClass:"fas fa-home"})]),_c('BreadCrumbItem',{attrs:{"disabled":""}},[_c('span',[_vm._v(_vm._s(this.$route.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }